import React from 'react';
import { Button, ButtonGroup } from '../ui-kit';
import { BarLoader } from 'react-spinners';
import { isUndefined } from 'lodash';

import SkillIcon from './SkillIcon';

const ButtonDutyFunctionSelect = ({ dutyFunctions, selectedDutyFunctionIds, loading, onClick }) => {
  if (!isUndefined(loading) && loading) return <BarLoader height="4px" width="100%" color="#C30000" />;

  return (
    <ButtonGroup className="d-flex flex-wrap">
      {dutyFunctions.map(dutyFunction => (
        <Button
          key={dutyFunction.id}
          value={dutyFunction.id}
          onClick={() => onClick([dutyFunction.id])}
          style={{ maxWidth: '120px', overflowX: 'clip' }}
          variant={selectedDutyFunctionIds.includes(dutyFunction.id) ? 'primary' : 'outline-secondary'}
        >
          <SkillIcon skill={dutyFunction} />
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ButtonDutyFunctionSelect;
